module.exports = __webpack_public_path__ + "img/info_listing2.efa90cf2.efa90cf2.jpg";